/** Route names that share Sales dashboard filter/session state. */
export const SALES_DASHBOARD_SHARED_ROUTE_NAMES = [
  'SalesDashboard',
  'SalesLeaderboard',
  'SalesSaleDetail',
  'SalesAmazonDashboard',
  'SalesOpenPipeline',
] as const

export type SalesDashboardSharedRouteName =
  (typeof SALES_DASHBOARD_SHARED_ROUTE_NAMES)[number]

export function isSalesDashboardSharedRoute(
  name: string | symbol | null | undefined
): name is SalesDashboardSharedRouteName {
  return (
    typeof name === 'string' &&
    (SALES_DASHBOARD_SHARED_ROUTE_NAMES as readonly string[]).includes(name)
  )
}
